const DEFAULT_STATE = {
  data: {},
  hasFailed: false,
  error: null,
  isLoaded: false,
  isLoading: true,
  dashboardLoaded: false,
  dashboardLoading: false,
  testAndTarget: true,
  currentStep: '',
};

/* Action Types */
export const APP_DATA = 'APP_DATA';
export const APP_DATA_FULFILLED = `${APP_DATA}_FULFILLED`;
export const APP_DATA_PENDING = `${APP_DATA}_PENDING`;
export const APP_DATA_REJECTED = `${APP_DATA}_REJECTED`;

export const DASHBOARD_APP_DATA = 'DASHBOARD_APP_DATA';
export const DASHBOARD_APP_DATA_FULFILLED = `${DASHBOARD_APP_DATA}_FULFILLED`;
export const DASHBOARD_APP_DATA_PENDING = `${DASHBOARD_APP_DATA}_PENDING`;
export const DASHBOARD_APP_DATA_REJECTED = `${DASHBOARD_APP_DATA}_REJECTED`;

export const TEST_AND_TARGET = 'TEST_AND_TARGET';
export const SET_CURRENT_STEP ='SET_CURRENT_STEP';

/* Reducers */
export default function applicationData(state = DEFAULT_STATE, action) {
  const { payload, type } = action;
  switch (type) {
    case APP_DATA_PENDING:
      return {
        ...state,
        data: payload,
        isLoading: true,
      };

    case APP_DATA_FULFILLED:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasFailed: false,
      };

    case APP_DATA_REJECTED:
      return {
        ...state,
        isLoading: false,
        hasFailed: true,
      };
    case DASHBOARD_APP_DATA_PENDING:
      return {
        ...state,
        data: payload,
        dashboardLoading: true,
      };

    case DASHBOARD_APP_DATA_FULFILLED:
      return {
        ...state,
        dashboardLoaded: true,
        dashboardLoading: false,
        hasFailed: false,
      };

    case DASHBOARD_APP_DATA_REJECTED:
      return {
        ...state,
        dashboardLoading: false,
        dashboardLoaded: true,
      };
    case TEST_AND_TARGET:
      return {
        ...state,
        testAndTarget: payload.target,
      };
    case SET_CURRENT_STEP:
      return {
        ...state,
        currentStep: payload.page,
      };
    default:
      return state;
  }
}

/* Actions */
export const applicationDataLoaded = () => ({
  type: APP_DATA_FULFILLED,
});
export const applicationDataLoading = () => ({
  type: APP_DATA_PENDING,
  payload: {
    urls: {
      hostDomain: '',
    },
  },
});
export const applicationDataFailed = () => ({
  type: APP_DATA_REJECTED,
});
export const dashboardDataLoaded = () => ({
  type: APP_DATA_FULFILLED,
});
export const dashboardDataLoading = () => ({
  type: APP_DATA_PENDING,
  payload: {
    urls: {
      hostDomain: '',
    },
  },
});
export const dashboardDataFailed = () => ({
  type: APP_DATA_REJECTED,
});
export const setCurrentStep = (page) => ({
  type: SET_CURRENT_STEP,
  payload: {
    page
  },
})
export const updateTestAndTarget = (props) => ({
  type: TEST_AND_TARGET,
  payload: props,
});
